export default __webpack_public_path__ + "static/media/vow1.1f3bdb6b.mp3";